module.exports = "<div id=\"main\" role=\"main\">\n  <iframe [src]=\"url\">\n  </iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/open-banking/open-banking.component.html
// module id = ../../../../../src/app/open-banking/open-banking.component.html
// module chunks = main